import { ValueLabel } from "@features/ax/shared/ValueLabel";

type Field = {
  label: string;
  value: string | React.ReactNode;
};
type DetailsSectionProps = {
  title: string;
  fields?: Field[];
  columns?: number; // optional for layout control
  emptyMessage?: string | React.ReactNode;
};

export const DetailsSection = ({
  title,
  fields,
  columns = 4,
  emptyMessage,
}: DetailsSectionProps) => {
  return (
    <div className="mb-6">
      {/* Section Title */}
      <div className="text-sm font-semibold tracking-wider text-gray-500 mb-2">
        {title}
      </div>

      {/* Card */}
      <div className="border border-gray-200 rounded-lg bg-white p-5">
        {emptyMessage ? (
          <p className="text-sm text-muted-foreground">{emptyMessage}</p>
        ) : (
          <div
            className={`grid gap-y-5 gap-x-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-${columns}`}
          >
            {fields?.map((field, index) => (
              <div key={index}>
                <ValueLabel
                  label={field.label}
                  value={field.value}
                  isHoverable={field.label.toLowerCase().includes("email")}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
